import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchStyles(themeId) {
  return NGXAjax.get(`/api/theme/showStyles.json?max=100&id=${themeId}`).then(resolve, reject);
}

export { fetchStyles };
